import React from "react";
const LoginButton = () => (
  <button
    type="submit"
    className="w-full bg-gray-200 py-2 px-4 rounded-lg text-gray-900 hover:bg-gray-300 transition-colors"
  >
    Iniciar sesión
  </button>
);
export default LoginButton;